import { DIRECTION } from 'enums'
import { time2Pixel } from '~/Util'
import { getIntersectionData } from './getIntersectionData'

export const setIntersectedXParams = ({
  staticAssets,
  draggableAssets,
  layers,
  offsetLayerIndex,
  dragItem,
  clientMousePosition,
  historyX,
  moveDirection,
  leftXOffset,
  scale,
  isIntersected,
  intersectedData,
  draggableBlockLeftX,
  draggableBlockDuration,
  isExternalSource,
  isPlaceholder,
}) => {
  let stopDragLeftX = 0
  let stopXNanoSecUnit = 0
  if (intersectedData) {
    if (moveDirection === DIRECTION.LEFT) {
      stopXNanoSecUnit = intersectedData.staticEndTime
      + intersectedData.dragFirstMinusCurrentStartTime
      stopDragLeftX = time2Pixel(intersectedData.staticEndTime
        + intersectedData.dragFirstMinusCurrentStartTime, scale) + leftXOffset
    } else {
      stopXNanoSecUnit = intersectedData.staticStartTime
      + intersectedData.dragEndMinusCurrentEndTime
      - intersectedData.draggableBlockDuration
      stopDragLeftX = time2Pixel(intersectedData.staticStartTime
        + intersectedData.dragEndMinusCurrentEndTime
        - intersectedData.draggableBlockDuration, scale) + leftXOffset
    }
  }

  if (stopDragLeftX < leftXOffset) {
    return
  }

  if ((historyX.current.isIncorrectPosition && !isPlaceholder)
    || (!historyX.current.intersectedData && historyX.current.isMountedOnLayer)) {
    // isIncorrectPosition - intersection with incorrect asset overlap. May occur when moving a group from one layer to another.
    let isIncorrectPosition = false
    if (isExternalSource) {
      isIncorrectPosition = staticAssets.find(sAsset => (stopXNanoSecUnit === sAsset.startTime)
      || (stopXNanoSecUnit + draggableBlockDuration === sAsset.endTime))
    } else {
      const { isOverlapped: isStopXOverlapped } = getIntersectionData({
        staticAssets,
        draggableAssets,
        layers,
        shiftingDragAssets: stopXNanoSecUnit - draggableAssets[0].startTime,
        offsetLayerIndex,
        isExternalSource,
        draggableBlockDuration,
        clientMousePosition,
        dragItem,
      })
      isIncorrectPosition = isStopXOverlapped
    }
    // eslint-disable-next-line no-param-reassign
    historyX.current = {
      ...historyX.current,
      isIntersected,
      stopDragLeftX: isIncorrectPosition ? draggableBlockLeftX : stopDragLeftX,
      intersectedData,
      moveDirection,
      isIncorrectPosition,
    }
  }
}
